module.exports = __webpack_public_path__ + "static/img/audioOff.39205a22.png";